<template>
  <div class="earnings-figures">
    <div class="title-wrap">
      <div class="tab-list">
        <div
          @click="changeLable(1)"
          :class="[activeLable == 1 ? 'name active' : 'name']"
        >
          <div class="earn-content">{{$vi18n('$i18n# 收益概览 #i18n$')}}</div>
        </div>
        <div
          @click="changeLable(2)"
          :class="[activeLable == 2 ? 'detail active' : 'detail']"
        >
          <div class="detail-content">{{$vi18n('$i18n# 收益明细 #i18n$')}}</div>
        </div>
        <div
          @click="changeLable(3)"
          :class="[activeLable == 3 ? 'income active' : 'income']"
        >
          <div class="income-content">{{$vi18n('$i18n# 作品收入数据 #i18n$')}}</div>
        </div>
      </div>
      <!-- <div class="title-name">$vi18n('$i1n# 收益概览 #i18n$')</div> -->
    </div>
    <OverviewCard v-if="activeLable == 1"></OverviewCard>
    <IndexPageTable v-else-if="activeLable == 2"></IndexPageTable>
    <ProIncomeData v-else-if="activeLable == 3"> </ProIncomeData>
    <NoviciateMask v-if="isNoviciateDeveloper"></NoviciateMask>
  </div>
</template>

<script>
import OverviewCard from './components/incomeData/overviewCard';
import IndexPageTable from './components/incomeData/indexPageTable';
import ProIncomeData from './components/incomeData/ProIncomeData.vue';
import NoviciateMask from '@/components/NoviciateMask'
import { mapState } from 'vuex';
export default {
  name: 'EarningsFigures',
  components: {
    OverviewCard,
    IndexPageTable,
    ProIncomeData,
    NoviciateMask
  },
  data() {
    return {
      activeLable: 1,
    };
  },
  computed: {
    ...mapState(['developerInfo']),
    isNoviciateDeveloper() {
      return this.developerInfo.dev_state === 2
    },
  },
  mounted() {
    this.Report('view', 'BeneficialDataPage');
  },
  methods: {
    changeLable(type) {
      this.activeLable = type;
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;
.earnings-figures {
  position: relative;
  .title-wrap {
    font-size: 18px;
    color: #595959;
    //padding-bottom: 24px;
    //border-bottom: 1px solid rgba(217, 217, 217, 1);
    margin-bottom: 24px;
    .tab-list {
      display: flex;
      cursor: default;
      color: #595959;
      border-bottom: 1px solid rgba(217, 217, 217, 1);
      //border-bottom: 1px solid #d9d9d9;
      .name {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        padding-bottom: 16px;
        margin-right: 19px;
        cursor: pointer;
        .earn-content {
          line-height: 26px;
        }
      }
      .name.active {
        border-bottom: 4px solid #fd9b21;
        position: relative;
        color: #fd9b21;
        &:before {
          display: block;
          content: '';
          width: 0;
          border-width: 4px;
          border-style: solid;
          border-color: transparent transparent $--color-primary transparent;
          position: absolute;
          left: 50%;
          margin-left: -2px;
          bottom: 0;
        }
      }
      .detail {
        padding-bottom: 16px;
        font-size: 20px;
        cursor: pointer;
        line-height: 26px;
        margin-right: 19px;
        .detail-name {
          line-height: 26px;
        }
      }
      .detail.active {
        border-bottom: 4px solid #fd9b21;
        position: relative;
        color: #fd9b21;
        &:before {
          display: block;
          content: '';
          width: 0;
          border-width: 4px;
          border-style: solid;
          border-color: transparent transparent $--color-primary transparent;
          position: absolute;
          left: 50%;
          margin-left: -2px;
          bottom: 0;
        }
      }
      .income {
        padding-bottom: 16px;
        font-size: 20px;
        cursor: pointer;
        line-height: 26px;
        .income-content {
          line-height: 26px;
        }
      }
      .income.active {
        border-bottom: 4px solid #fd9b21;
        position: relative;
        color: #fd9b21;
        &:before {
          display: block;
          content: '';
          width: 0;
          border-width: 4px;
          border-style: solid;
          border-color: transparent transparent $--color-primary transparent;
          position: absolute;
          left: 50%;
          margin-left: -2px;
          bottom: 0;
        }
      }
    }
  }
}
</style>
